import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var SubscriptionInformationTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(SubscriptionInformationTransformer, _BaseTransformer);
  var _super = _createSuper(SubscriptionInformationTransformer);
  function SubscriptionInformationTransformer() {
    _classCallCheck(this, SubscriptionInformationTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(SubscriptionInformationTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        // productName: data.product_name,
        // planName: data.plan_name,
        // licenseAmount: data.license_amount,
        // billing: data.billing,
        // renewsOn: data.renews_on
        activeCount: data.active_count,
        activeGuestCount: data.active_guest_count,
        app_name: data.app_name,
        createdOn: data.created_on,
        editionName: data.edition_name,
        guestCount: data.guest_count,
        id: data.id,
        label: data.label,
        maxConcurrent_logins: data.max_concurrent_logins,
        packageApp_id: data.package_app_id,
        packageEdition_id: data.package_edition_id,
        packageId: data.package_id,
        packageName: data.package_name,
        remaining: data.remaining,
        remainingGuest: data.remaining_guest,
        totalCount: data.total_count
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {
        active_count: data.activeCount,
        active_guest_count: data.activeGuestCount,
        app_name: data.app_name,
        created_on: data.createdOn,
        edition_name: data.editionName,
        guest_count: data.guestCount,
        id: data.id,
        label: data.label,
        max_concurrent_logins: data.maxConcurrent_logins,
        package_app_id: data.packageApp_id,
        package_edition_id: data.packageEdition_id,
        package_id: data.packageId,
        package_name: data.packageName,
        remaining: data.remaining,
        remaining_guest: data.remainingGuest,
        total_coun: data.totalCountt
      };
    }
  }]);
  return SubscriptionInformationTransformer;
}(BaseTransformer);